import RestraintInteractionHandler3D from "oc-interaction/restraints2/RestraintInteractionHandler3D.js";
import Interieur from "../arrangement/Interieur";
import HeightDragHandle from "../object3d/HeightDragHandle";
import RFHeightDragHandle from "./restraintfactories/RFHeightDragHandle";
import RFInterieur from "./restraintfactories/RFInterieur";
import RFFullHeightDrag from "./restraintfactories/RFFullHeightDragable";
import RFBohrlochleiste from "./restraintfactories/RFInterieurBohrlochleiste";
import DeviceDetection from "oc-commons/DeviceDetection";

export default class InteractionHandler extends RestraintInteractionHandler3D {
    isDragging = false;

    constructor(rootContainer) {
        super(rootContainer);
    }

    getRestraintsAndSnapsForHandle() {
        let restraints = null;
        if (this.dragObject3d instanceof HeightDragHandle) {
            restraints = new RFHeightDragHandle(this).getRestraints();
        } else if (this.dragObject3d.vsData.fullHeightDrag) {
            restraints = new RFFullHeightDrag(this).getRestraints();
        } else if (this.dragObject3d.vsData.bohrlochleiste) {
            restraints = new RFBohrlochleiste(this).getRestraints();
        } else if (this.dragObject3d.vsData instanceof Interieur) {
            restraints = new RFInterieur(this).getRestraints();
        }
        return restraints;
    }

    onDrag3d() {
        this.isDragging = true;
        super.onDrag3d();
        APP.model.setDirty();
    }

    onDrag3dBegin() {
        super.onDrag3dBegin();
        APP.model.doNotThrowCompileErrors = true;
        this.safepoint = APP.model.createCompilationSafePoint();

        if (!(this.dragObject3d instanceof HeightDragHandle)) {
            InteractionHandler.detachFromElement(this.dragObject3d);
        }
    }

    onTapObject3D() {
        super.onTapObject3D();
    }

    onDrop3d() {
        APP.model.doNotThrowCompileErrors = false;
        super.onDrop3d();
    }

    onDrag3dEnd() {
        APP.model.doNotThrowCompileErrors = false;
        super.onDrag3dEnd();
        this.isDragging = false;
        try {
            this.safepoint.compile();
        } catch(e) {
            this.safepoint.rollback();
            this.safepoint.maybeShowError();
        }
        this.safepoint = null;
        APP.model.setDirty();
    }

    static attachToElement(dragObject3d, element) {
        const interieur = dragObject3d.vsData;
        const containerO3 = element.child3dContainer;
        containerO3.attach(dragObject3d);

        element.addInterieur(interieur);

        APP.model.atttachToCompilation(dragObject3d);
        
    }

    static detachFromElement(dragObject3d) {
        const interieur = dragObject3d.vsData;
        interieur.removeFromElement();
        APP.model.detachFromCompilation(dragObject3d);
        
        if (interieur.type == 'Tuer') {
            APP.arrangement.object3d.ruler.updateRulerStyle(false);
            STAGE.dirty();
        }

        if (Scenes.isInScene(dragObject3d)) {
            STAGE.scene.attach(dragObject3d);
        }
    }
}
